const Usage = {
  init() {
    if ($('.usage').length !== 1) return;

    $('.usage-selector').change(this.handleUsageSelectorChange.bind(this));
    $('#usage-submit').prop('disabled', true);
    $('#usage-submit').hide();
  },

  handleUsageSelectorChange() {
    var elements = $('.usage-selector').toArray();
    elements.unshift(false);
    const areAnyUnselected = elements.reduce(function(anyUnselected, element) {
      return anyUnselected || $(element).find('option:selected').val() == 'unselected';
    });

    if(!areAnyUnselected) {
      $('#usage-submit').prop('disabled', false);
      $('#usage-submit').show();
    } else {
      $('#usage-submit').prop('disabled', true);
      $('#usage-submit').hide();
    }

  }
}

$(document).ready(()=> {
  Usage.init();
});
